import request from 'utils/request';
import { DictionaryDto, PagedView } from './dictionary';
import { BranchTypes } from './types/BranchTypes';

export function initBranch(): BranchDto {
    return {
        address: '',
        code: '',
        is_open: true,
        has_children: false,
        latitude: 0,
        longitude: 0,
        title: '',
        region: {
            id: '',
            code: '',
            description: '',
            status: 'ACTIVE',
        },
        iic: '',
        bin: '',
        director_full_name: '',
        trn: '',
        bic: '',
        original_new_post_index: '',
        last_new_post_index: '',
        branch_type: {
            id: '',
            code: '',
            description: '',
            status: 'ACTIVE',
        },
        relog_api_key: '',
        relog_enabled: false,
    };
}

export interface BranchDto {
    address: string;
    code: string;
    id?: number;
    is_open: boolean;
    has_children: boolean;
    latitude: number | string;
    longitude: number | string;
    region?: DictionaryDto;
    title: string;
    iic: string;
    trn: string;
    bin: string;
    director_full_name: string;
    bic: string | undefined;
    original_new_post_index?: string | null;
    last_new_post_index?: string | null;
    branch_type?: BranchTypes | null;
    relog_api_key?: string;
    relog_enabled?: boolean;
}

export const getBranches = (
    page: number,
    size: number,
    sort: string,
    value: string | null,
    region_code: string | null
): Promise<PagedView<BranchDto>> => {
    return request
        .get('/branch/list', { params: { page, size, sort, value, region_code } })
        .then(({ data }) => data as PagedView<BranchDto>);
};

export const getOpenBranches = (params: {
    value: string | null;
    region_code: string | null;
}): Promise<BranchDto[]> => {
    return request.get('/branch/get-list', { params }).then(({ data }) => data as BranchDto[]);
};

export const getUserBranches = (
    region_code?: string | null,
    product_code?: string | null
): Promise<BranchDto[]> => {
    return request
        .get('/branch/user', { params: { region_code, product_code } })
        .then(({ data }) => data as BranchDto[]);
};

export const getAllBranches = (search = ''): Promise<PagedView<BranchDto>> => {
    const params = search ? { search } : {};
    return request
        .get('/branch/all-active', { params })
        .then(({ data }) => data as PagedView<BranchDto>);
};

// @ts-ignore
export function fetchBranchesHierarchy(
    parent_code: string | null,
    region_code: string | null
): Promise<{ data: BranchDto[]; total: number }> {
    return request('/branch/hierarchy', {
        method: 'POST',
        data: { parent_code },
        params: { region_code },
    }).then((info) => {
        const { data, headers } = info;
        return { data, total: Number(headers['x-total-count']) };
    });
}

export const getBranchActiveTypes = (): Promise<PagedView<BranchTypes>> => {
    return request
        .get('/branch-type/active/list ')
        .then(({ data }) => data as PagedView<BranchTypes>);
};
